<template>
  <div class="train-details" :class="TrainData.isEvaluate === 'N' &&
      TrainData.studentCode === 'Y' &&
      TrainData.publishStatus !== '3' &&
      TrainData.status !== '2'
      ? 'toeva'
      : ''
    ">
    <div class="block-div" v-if="TrainCheckUser">
      <off-line-component v-if="TrainData.onlineStatus == '2'" :TrainDateListArr="TrainDateListArr"
        :TrainData="TrainData" @signUpSuccess="handleCheck"></off-line-component>
      <line-zoom-component v-else-if="TrainData.onlineStatus == '1'" :TrainDateListArr="TrainDateListArr"
        :TrainData="TrainData" @signUpSuccess="handleCheck"></line-zoom-component>
      <div class="train-title" v-if="TrainCourseDataList.length > 0">
        <div class="title-txt">预习课程</div>
      </div>
      <div class="train-block course-info" v-if="TrainCourseDataList.length > 0">
        <div class="course-info-title">课程要求</div>
        <div class="course-info-txt">{{ TrainData && TrainData.courseRequirement }}</div>
        <div class="course-list">
          <div class="course-item" v-for="(item, index) in TrainCourseDataList" :key="index" @click="handleDialogUnlock(item)">
            <!-- <div class="course-item" v-for="(item, index) in TrainCourseDataList" :key="index"  v-track="{functionName: item.courseName}" @click="gotoVideo(item)"> -->
            <img v-if="item && item.coverMaterial" :src="item && item.coverMaterial.url" class="course-item-cover" alt="" />
            <div v-else class="course-item-cover"></div>
            <div class="tag status1" v-if="item.state === 3">
              {{ item && item.statusTxt }}
            </div>
            <div class="tag status2" v-if="item.state === 2">
              {{ item && item.statusTxt }}
            </div>
            <div class="tag status3" v-if="item.state === 1">
              {{ item && item.statusTxt }}
            </div>
            <div class="course-txt">{{ item && item.courseName }}</div>
            <div class="item-unlock" v-if="`${item.isUnlock}` === '1' && !item.myUnlock">
              <img src="@/assets/images/data-base/unlock.png" class="icon-unlock" alt="">
              <span class="txt">{{ item && item.unlockCost }}积分解锁</span>
            </div>
          </div>
        </div>
      </div>
      <div class="train-title" v-if="TrainStudentListArr.length > 0">
        <div class="title-txt">学员</div>
      </div>
      <div class="train-block student-info" v-if="TrainStudentListArr.length > 0">
        <div class="student-list">
          <div class="student-item" v-for="(item, index) in TrainStudentListArr" :key="index">
            <template
              v-if="item.iepUserId === userInfo.id || (TrainData.lecturerCode === 'Y' && TrainData.studentCode === 'N')">
              <div class="item-sort" v-if="item.sort === 1">
                <img src="@/assets/images/train/sort(3).png" class="sort-img" alt="" />
                <div class="sort-txt">1</div>
              </div>
              <div class="item-sort" v-if="item.sort === 2">
                <img src="@/assets/images/train/sort(2).png" class="sort-img" alt="" />
                <div class="sort-txt">2</div>
              </div>
              <div class="item-sort" v-if="item.sort === 3">
                <img src="@/assets/images/train/sort(1).png" class="sort-img" alt="" />
                <div class="sort-txt">3</div>
              </div>
              <div class="item-sort" v-if="item.sort > 3">
                <img src="@/assets/images/train/sort(4).png" class="sort-img" alt="" />
                <div class="sort-txt">{{ item && item.sort }}</div>
              </div>
            </template>
            <img v-if="item.headPicUrl" :src="item.headPicUrl" class="student-item-cover" alt="" />
            <div v-else-if="item.realName" class="student-item-cover">
              {{ item.realName.substring(0, 1) }}
            </div>
            <div v-else class="student-item-cover">...</div>
            <div class="student-item-info">
              <div class="item-flex-txt">
                <span class="item-txt">{{ item.realName }}</span>
                <span class="item-tag">｜{{ item.hospitalName }}</span>
              </div>
              <div class="student-tag"
                v-if="item.iepUserId === userInfo.id || (TrainData.lecturerCode === 'Y' && TrainData.studentCode === 'N')">
                <div class="tag tag1">
                  {{ item.isSign === 'Y' ? '已签到' : '未签到' }}
                </div>
                <div class="tag tag2">
                  预习 {{ item.studyRatio }}
                </div>
              </div>
            </div>
            <!-- <div class=" ">点击签到</div> -->
          </div>
        </div>
      </div>
      <div class="submit-btn" v-if="TrainData.isEvaluate === 'N' &&
    TrainData.studentCode === 'Y' &&
    TrainData.publishStatus !== '3' &&
    TrainData.status !== '2'" @click="gotoEva">
        <!-- ((TrainData.studentSpeakerSign === 'N' &&
            roleTypes === 4 &&
            certificateNo !== '5') ||
            (TrainData.directorStudentSgin === 'Y' && certificateNo === '5')) -->
        请对本次活动进行评价，谢谢。
      </div>
      <div class="cancel-info-title" v-if="TrainData.publishStatus === '3'">
        <img src="@/assets/images/train/train_cnacel.png" class="cancel" alt="" />
        取消
      </div>
      <div class="train-block cancel-block" v-if="TrainData.publishStatus === '3'">
        <div class="info">
          <div class="label">取消原因</div>
          <div class="val">{{ TrainData.cancelReason }}</div>
        </div>
        <div class="info">
          <div class="label">备注</div>
          <div class="val">{{ TrainData.cancelRemark }}</div>
        </div>
      </div>
    </div>
    <div class="block-none" v-else>
      <img src="../../assets/images/train/img_none.png" class="img-none" alt="" />
      <div class="block-none-txt">暂无权限访问</div>
    </div>
    <dialog-unlock ref="dialogUnlock" @unlockSuccess="handleJump" :dataProps="dataProps"></dialog-unlock>
  </div>
</template>

<script>
import { trainDetails, trainDetailsCourse, trainDetailstudent, trainDetailSchedules, trainCheck } from '@/api/train.js'
import { BOOL_LECTURE } from '@/utils/configRoles.js'
import OffLineComponent from './components/OffLineComponent.vue'
import LineZoomComponent from './components/LineZoomComponent.vue'
import { getShareInfo } from '@/utils/wxShare'
import dialogUnlock from '@/components/dialogUnlock.vue'
import withRouteTracking from '@/utils/withRouteTracking'
import {isScorm} from '../../api/scorm'
const UserProfile = {
  name: 'trainDetails',
  components: {
    OffLineComponent,
    LineZoomComponent,
    dialogUnlock
  },
  data () {
    return {
      TrainData: {},
      TrainCourseDataList: [],
      TrainStudentListArr: [],
      TrainDateListArr: [],
      TrainCheckUser: true,
      BOOL_LECTURE,
      dataDetails: {},
      dataProps: {
        unlockContent: '兑换EP公开课课程',
        unlockTxt: '课程'
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    this.handleCheck()
  },
  methods: {
    handleDialogUnlock (item) {
      this.dataDetails = item
      if (`${item.isUnlock}` === '1' && !item.myUnlock) {
        this.dataProps.baseId = item.courseId
        this.dataProps.unlockCost = item.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      this.handleJump()
    },
    // 跳转到详情
    async handleJump () {
      window.sessionStorage.setItem('entrance', '13')
      let data = this.dataDetails
      const query = {
        courseId: data.courseId,
        journeyId: data.journeyId,
        businessId: data.journeyId,
        entrance: '13',
        channel: '13'
      }
      const isscorm = await isScorm(data.courseId)
      let path = '/courserDetails'
      if (isscorm.data) {
        path = '/scormCourseDetail'
      }
      this.$router.push({path, query})
    },
    // 判断当前用户是否有权限观看活动详情
    handleCheck () {
      let params = {
        activityId: this.$route.query.trainId,
        activityHospitalId: this.$route.query.hospitalId,
        userHospitalId: this.userInfo.hospitalId
      }
      if (this.$route.query.inletType) {
        params.inletType = this.$route.query.inletType
      }
      trainCheck(params).then(res => {
        this.TrainCheckUser = res.data
        if (this.TrainCheckUser) {
          this.handleGetTrainDetails()
          this.handleGetCourse()
          this.handleGetSchedules()
        }
      })
    },
    // 获取活动详情
    handleGetTrainDetails () {
      const params = {
        trainId: this.$route.query.trainId,
        iepUserId: this.userInfo.id
      }
      trainDetails(params).then(res => {
        this.TrainData = res.data
        window.sessionStorage.setItem('mainId', this.TrainData.id)
        window.sessionStorage.setItem('traceTitle', '学术活动-' + this.TrainData.title)
        getShareInfo({
          title: 'iEP-中国电生理术者充电站',
          titleTimeLine: 'iEP-中国电生理术者充电站',
          desc: '更智慧、更全面、更懂你。',
          link: window.location.href,
          linkTimeLine: window.location.href,
          images: `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`,
        })
        this.handleGetStudents(res)
      })
    },
    // 获取活动课程
    handleGetCourse () {
      trainDetailsCourse({
        trainId: this.$route.query.trainId,
        iepUserId: this.userInfo.id
      }).then(res => {
        this.TrainCourseDataList = res.data.map((item) => {
          item.statusTxt = ''
          switch (item.state) {
            case 1:
              item.statusTxt = '已完成'
              break
            case 2:
              item.statusTxt = '进行中'
              break
            case 3:
              item.statusTxt = '未开始'
              break
          }
          return item
        })
      })
    },
    // 获取学员列表
    handleGetStudents (returnObj) {
      trainDetailstudent({
        activityId: this.$route.query.trainId,
        iepUserId: this.userInfo.id,
        isMate: this.userInfo.hospitalId === (returnObj.data.hospital ? returnObj.data.hospital.id : '')
      }).then(res => {
        let curStudent = res.data.filter((item) => {
          return item.iepUserId === this.userInfo.id
        })
        let otherStudent = res.data.filter((item) => {
          return item.iepUserId !== this.userInfo.id
        })
        this.TrainStudentListArr = curStudent.concat(otherStudent)
      }).catch(() => {
        console.log('当前活动没有学员!')
      })
    },
    handleGetSchedules () {
      trainDetailSchedules({
        academicActivityId: this.$route.query.trainId
      }).then(res => {
        this.TrainDateListArr = res.data
      })
    },

    gotoEva () {
      this.$router.push({
        path: '/train/evaluate',
        query: {
          trainId: this.$route.query.trainId
        }
      })
    }
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.train-details {
  background: #F2F2F2;
  padding-bottom: 8px;
  box-sizing: border-box;
  min-height: 100vh;

  &.toeva {
    padding-bottom: 72px;
  }

  .train-block {
    background-color: #fff;
    border-radius: 4px;
    margin: 0 12px;
    margin-bottom: 8px;

    &.course-info {
      padding: 16px 11px;
      box-sizing: border-box;

      .course-info-title {
        font-size: 14px;
        color: #2b2b2b;
        font-weight: 600;
        margin-bottom: 9px;
        line-height: 17px;
        padding-top: 4px;
        box-sizing: border-box;
      }

      .course-info-txt {
        color: #2b2b2b;
        font-size: 12px;
        line-height: 17px;
      }

      .course-list {
        display: flex;
        margin-top: 16px;
        flex-wrap: wrap;

        .course-item {
          width: 103px;
          margin-right: 9px;
          margin-bottom: 10px;
          position: relative;

          &:nth-child(3n) {
            margin-right: 0;
          }

          .tag {
            position: absolute;
            width: 50px;
            height: 24px;
            background-color: #EB1700;
            display: flex;
            align-items: center;
            line-height: 24px;
            justify-content: center;
            font-size: 12px;
            color: #fff;
            top: 0;
            right: 0;
            border-bottom-left-radius: 12px;
            border-top-right-radius: 12px;

            &.status1 {
              background-color: #FF6017;
            }

            &.status2 {
              background-color: #EB1700;
            }

            &.status3 {
              background-color: #328714;
            }
          }

          .course-item-cover {
            width: 103px;
            height: 60px;
            margin-bottom: 6px;
          }

          .course-txt {
            line-height: 17px;
            height: 34px;
            color: #2b2b2b;
            font-size: 12px;
            text-align: left;
            padding: 0 8px;
            box-sizing: border-box;
            display: -webkit-box;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
          .item-unlock {
            display: flex;
            align-items: center;
            height: 20px;
            margin-top: 2px;
            padding: 0 8px;
            box-sizing: border-box;

            .icon-unlock {
              width: 10px;
              margin-right: 4px;
              display: block;
            }

            .txt {
              color: #EB1700;
              font-size: 12px;
            }
          }
        }
      }
    }

    &.student-info {
      .student-info-title {
        font-size: 12px;
        color: #2b2b2b;
        font-weight: 600;
        padding-top: 18px;
        padding-left: 14px;
        box-sizing: border-box;
        line-height: 17px;
        margin-bottom: 7px;
      }

      .student-list {
        padding: 0 5px;
        box-sizing: border-box;

        .student-item {
          display: flex;
          padding: 10px 15px;
          box-sizing: border-box;
          border-bottom: 1px solid #f0f1f6;
          position: relative;
          align-items: center;

          .item-sort {
            position: absolute;
            width: 18px;
            height: 21px;
            display: flex;
            justify-content: center;
            align-content: center;
            top: 10px;

            .sort-img {
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
            }

            .sort-txt {
              color: #fff;
              font-size: 12px;
              font-weight: 500;
              position: relative;
              line-height: 18px;
            }
          }

          &:nth-last-child(1) {
            border: none;
          }

          .student-item-cover {
            width: 50px;
            height: 50px;
            margin-right: 12px;
            border-radius: 50%;
            object-fit: cover;
            background-color: #e6e6e6;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            color: #333333;
            font-weight: bold;
          }

          .student-item-info {
            flex: 1;

            .item-flex-txt {
              display: flex;

              .item-txt {
                font-size: 14px;
                color: #2b2b2b;
                line-height: 17px;
                font-weight: 500;
                margin-right: 4px;
              }

              .item-tag {
                font-size: 10px;
                color: #5b5f6a;
              }
            }

            .student-tag {
              display: flex;
              margin-top: 5px;
              align-items: center;

              .tag1 {
                text-align: center;
                width: 37px;
                height: 16px;
                line-height: 16px;
                border-radius: 4px;
                margin-right: 10px;
                color: #EB1700;
                font-size: 8px;
                border: 1px solid #EB1700;
              }

              .tag2 {
                text-align: center;
                width: 42px;
                height: 16px;
                line-height: 16px;
                border-radius: 4px;
                border: 1px solid #EB1700;
                font-size: 8px;
                color: #EB1700;
              }
            }
          }

          .span-btn {
            width: 72px;
            height: 24px;
            border-radius: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #EB1700;
            color: #fff;
            font-size: 12px;
            align-self: center;
          }
        }
      }
    }
  }

  .train-title {
    padding: 20px 0 7px 27px;

    .title-txt {
      line-height: 22px;
      font-size: 16px;
      color: #333333;
      font-weight: 600;
      position: relative;

      &::before {
        position: absolute;
        width: 4px;
        height: 12px;
        background-color: #EB1700;
        border-radius: 4px;
        left: -10px;
        content: '';
        bottom: 4px;
      }
    }
  }

  .cancel-info-title {
    font-size: 14px;
    color: #2b2b2b;
    font-weight: 600;
    margin-bottom: 5px;
    margin-top: 18px;
    margin-left: 18px;
    display: flex;
    align-items: center;

    .cancel {
      width: 12px;
      height: 12px;
      margin-right: 6px;
    }
  }

  .cancel-block {
    padding: 16px 14px;
    box-sizing: border-box;

    .info {
      display: flex;
      margin-bottom: 16px;

      &:nth-last-child(1) {
        margin-bottom: 0;
      }

      .label {
        width: 48px;
        text-align: right;
        margin-right: 12px;
        font-size: 12px;
        color: #2b2b2b;
        font-weight: 500;
      }

      .val {
        font-size: 12px;
        color: #2b2b2b;
        flex: 1;
      }
    }
  }

  .submit-btn {
    position: fixed;
    bottom: 17px;
    left: 16px;
    border-radius: 30px;
    background: #EB1700;
    width: 343px;
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #ffffff;
    justify-content: center;
  }
}

.block-none {
  padding-top: 188px;
  box-sizing: border-box;

  .img-none {
    width: 120px;
    height: 104px;
    margin-bottom: 12px;
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .block-none-txt {
    font-size: 14px;
    color: #5b5f6a;
    line-height: 20px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/academicActivities/trainDetails.vue